//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'
import { formatFiltersForServer } from './ServerFilterUtils.js'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    filterUrlParameters: {
      type: String,
      default: ''
    },
    globalFilterProfileChangeAccess: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default () {
        return {}
      }
    },
    filterProfiles: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      nameFilterProfile: '',
      globalFilterProfile: false,
      loading: false,
      saveMode: 'write',
      selectedFilterProfileForOverwrite: null
    }
  },
  watch: {
    opened: function (result) {
      if (result) {
        this.nameFilterProfile = ''
        if (this.filters.profile && !['$user_custom', 'Пользовательский'].includes(this.filters.profile)) {
          this.saveMode = 'overwrite'
          this.selectedFilterProfileForOverwrite = this.filters.profile
          console.log(this.filterProfiles)
          this.globalFilterProfile = this.filterProfiles.find(fl => fl.name === this.filters.profile).global
        } else {
          this.saveMode = 'write'
          this.globalFilterProfile = false
          this.selectedFilterProfileForOverwrite = null
        }
      }
    }
  },
  methods: {
    confirm: function () {
      this.$emit('confirm')
    },
    onClose: function () {
      this.$emit('close')
    },
    onSaveFilterProfile: function () {
      this.loading = true

      const bodyFormData = new FormData()
      const formattedFiltersForServer = formatFiltersForServer(JSON.parse(JSON.stringify(this.filters)))
      bodyFormData.set('data', JSON.stringify(formattedFiltersForServer))

      let url = ''

      if (this.saveMode === 'write') {
        url = '/service/delta/dispatcher/setfilterprofile?' +
              this.filterUrlParameters +
              '&name=' + this.nameFilterProfile +
              '&global=' + this.globalFilterProfile
      } else if (this.saveMode === 'overwrite') {
        let profileName = this.selectedFilterProfileForOverwrite
        if (this.selectedFilterProfileForOverwrite === 'Пользовательский') {
          profileName = '$user_custom'
        }

        url = '/service/delta/dispatcher/setfilterprofile?' +
              this.filterUrlParameters +
              '&name=' + profileName +
              '&global=' + this.globalFilterProfile
      }

      axiosPost({
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Профиль фильтрации успешно сохранен',
            progress: true,
            timeout: 8000
          })
        },
        onFailure: 'Ошибка сохранения профиля фильтрации',
        msgTarget: this
      }).finally(() => {
        this.loading = false
        this.confirm()
      })
    }
  }
}

